// @flow
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { type Match, Route, NavLink } from 'react-router-dom';

import { catalogPages } from 'view/App/pageData';
import type { Catalog } from 'state/types';

type CatalogNavLinkProps = {
  catalog: Catalog,
  subPage?: string,
};

export const CatalogNavLink = ({ catalog, subPage }: CatalogNavLinkProps) => {
  return (
    <tr>
      <td className="no-padding">
        <NavLink
          className="list-item nav-item-list"
          activeClassName="nav-item-list-selected"
          to={`/catalogs/${catalog.catalogId}${subPage ? '/' + subPage : ''}`}
          data-test-name={'catalog-select-' + catalog.name}
        >
          {catalog.name}
        </NavLink>
      </td>
    </tr>
  );
};

type CatalogRouteProps = {
  match: Match,
  catalog: Catalog,
};

export const CatalogRoute = ({ match, catalog }: CatalogRouteProps) => {
  return (
    <Route
      key={catalog.catalogId}
      path={`${match.path}/:catalogId`}
      render={props => <CatalogSubroute catalog={catalog} {...props} />}
    />
  );
};

type CatalogSubrouteProps = {
  match: Match,
  catalog: Catalog,
};

export const CatalogSubroute = ({ match, catalog }: CatalogSubrouteProps) => {
  if (catalog && match.url.includes(`catalogs/${catalog.catalogId}`)) {
    return (
      <div
        className="column"
        style={{
          height: 'calc(100% - 64px)' /** FIXME: hack for bug PORT-11900 */,
        }}
      >
        <header className="page-header-tabs-container">
          <div className="tabs is-centered is-full-width">
            <ul>
              {catalogPages.map(page => (
                <li key={page.label.defaultMessage}>
                  <NavLink
                    className="nav-item-horizontal"
                    activeClassName="nav-item-horizontal-selected"
                    to={`${match.url}/${page.subroute}`}
                    data-test-name={page.dataTestName}
                  >
                    <FormattedMessage {...page.label} />
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
        </header>

        <Route
          path={`${match.path}/:subroute`}
          render={props => <CatalogPage catalog={catalog} {...props} />}
        />
      </div>
    );
  } else {
    return null;
  }
};

const CatalogPage = ({ match, catalog }) => {
  const page = catalogPages.find(p => p.subroute === match.params.subroute);

  return (
    <div className="page-contents">
      {page && page.contents ? (
        <page.contents.component catalog={catalog} />
      ) : (
        <div>
          {/* TODO: remove when all catalog pages are completed, used to prove subrouting is working*/}
          <h3>Subroute: {match.params.subroute}</h3>
          <h3>Catalog Id: {match.params.catalogId}</h3>
        </div>
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/view/Pages/CatalogsPage/CatalogRoutes.js